/*
 *
 * OrdersPage reducer
 *
 */

import { FulfillmentNote, Order } from 'types/schema';
import ActionTypes from './constants';
import { ContainerActions, ContainerState } from './types';

const loadingResources = Array(48)
  .fill(0)
  .map((v, i) => ({ loading: true, id: i }));

export const initialState: ContainerState = {
  isOpen: false,
  orders: {
    data: loadingResources,
    totalResults: 0,
    hasMore: true,
    loading: false,
  },
  selectedNote: {},
  search: {
    filter: {
      supplierName: '',
      statuses: [],
      orderDateRange: null,
      deliveryDateRange: null,
    },
    pagination: {
      page: 0,
      size: 48,
    },
  },
  tabCounts: {
    pending: null,
    waiting: null,
  },
};

function ordersPageReducer(state: ContainerState = initialState, action: ContainerActions): ContainerState {
  const { type, payload } = action as any;
  switch (type) {
    case ActionTypes.FETCH_ORDERS_REQUEST:
      return {
        ...state,
        orders: { ...state.orders, loading: true },
      };
    case ActionTypes.FETCH_ORDERS_SUCCESS:
      const { orders, search } = payload;
      const isFirstPage = search.pagination.page === 0;
      return {
        ...state,
        orders: {
          ...orders,
          loading: false,
          data: isFirstPage ? orders.data : state.orders.data.filter((i) => !i.loading).concat(orders.data),
          hasMore:
            orders.data.length > 0 && orders.totalResults > (search.pagination.page + 1) * search.pagination.size,
        },
        search: search,
      };
    case ActionTypes.ORDERS_EXPORT_CSV_SUCCESS:
      return {
        ...state,
        search: payload.search,
      };
    case ActionTypes.SET_FILTER:
      return {
        ...state,
        search: payload,
      };
    case ActionTypes.APPROVE_ORDER_SUCCESS:
      return {
        ...state,
        orders: {
          ...state.orders,
          data: state.orders.data
            .map((order: Order) => {
              if (order.id === payload.id) {
                return { ...order, status: payload.status, statusText: payload.statusText };
              }
              return order;
            })
            .filter((order: Order) => {
              if (state.search.filter.statuses && state.search.filter.statuses.length > 0) {
                return state.search.filter.statuses.includes(order.status);
              }
              return true;
            }),
        },
      };
    case ActionTypes.DISAPPROVE_ORDER_SUCCESS:
      return {
        ...state,
        orders: {
          ...state.orders,
          data: state.orders.data
            .map((order: Order) => {
              if (order.id === payload.id) {
                return { ...order, status: payload.status, statusText: payload.statusText };
              }
              return order;
            })
            .filter((order: Order) => {
              if (state.search.filter.statuses && state.search.filter.statuses.length > 0) {
                return state.search.filter.statuses.includes(order.status);
              }
              return true;
            }),
        },
      };
    case ActionTypes.RATING_MODAL_OPEN:
      return {
        ...state,
        isOpen: true,
        selectedNote: payload,
      };
    case ActionTypes.RATING_MODAL_CLOSE:
      return {
        ...state,
        isOpen: false,
        selectedNote: {},
      };
    case ActionTypes.RATE_SUCCESS:
      return {
        ...state,
        isOpen: false,
        selectedNote: {},
        orders: {
          ...state.orders,
          data: state.orders.data.map((ffm: FulfillmentNote) => {
            if (ffm.__typename === 'FulfillmentNote' && ffm.fulfillmentNoteId === payload.objectId) {
              return { ...ffm, feedback: payload };
            }
            return ffm;
          }),
        },
      };
    case ActionTypes.RATE_FAILURE:
      return {
        ...state,
        isOpen: false,
        selectedNote: {},
      };
    case ActionTypes.LOAD_MORE_ORDERS:
      return {
        ...state,
        search: {
          ...state.search,
          pagination: {
            ...state.search.pagination,
            page: state.search.pagination.page + 1,
          },
        },
      };
    case ActionTypes.FETCH_TAB_COUNTS_SUCCESS:
      return {
        ...state,
        tabCounts: {
          pending: payload.pending,
          waiting: payload.waiting,
        },
      };
    case ActionTypes.FETCH_TAB_COUNTS_FAILURE:
      return {
        ...state,
        tabCounts: {
          pending: null,
          waiting: null,
        },
      };
    default:
      return state;
  }
}

export default ordersPageReducer;
